import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightElement,
  Stack,
  Select,
} from "@chakra-ui/react";

import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { useHistory } from "react-router-dom";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import Pagination from "components/dataDispaly/Pagination";

// Assets
import {
  MdCheckCircle,
  MdCancel,
  MdUpdate,
  MdDelete,
  MdWarning,
  MdCreate,
} from "react-icons/md";
export default function UserTable(props) {
  // custom variable

  const history = useHistory();

  // Use state variable
  const { columnsData } = props;
  const [data, setData] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [dataPageSize, setDataPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [inputUsername, setUsername] = useState();
  const [inputEmail, setEmail] = useState();
  const [inputPassword, setPassword] = useState();
  const [inputRole, setRole] = useState("");
  const [selectedRow, setSelectedRow] = useState();
  const [selectedOptionsRole, setSelectedOptionsRole] = useState([]);
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  // ref variable
  const skipPageResetRef = React.useRef();
  const cancelRef = React.useRef();
  // memo variable
  const columns = useMemo(() => columnsData, [columnsData]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageCount: dataPage },
      manualPagination: true,
      pageCount: dataPage,
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const enableDisableUser = async (username) => {
    try {
     // console.log(username.row.cells[0].value);
      if (username.row.cells[3].value === true) {
        let response = await ApiService.client
          .put(
            `/auth/disable/` + username.row.cells[0].value,
            {},
            await ApiService.options()
          )
          .then((response) => {
            window.location.reload();
          });
      } else if (username.row.cells[3].value === false) {
        let response = await ApiService.client
          .put(
            `/auth/enable/` + username.row.cells[0].value,
            {},
            await ApiService.options()
          )
          .then((response) => {
            window.location.reload();
          });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const updateUser = async (dataUser) => {
    try {
     // console.log(dataUser.row.cells[0].value);
      let response = await ApiService.client
        .put(
          `/auth/update/` + dataUser.row.cells[0].value,
          { email: inputEmail, password: inputPassword, role_id: String(inputRole) },
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const registerUser = async () => {
    try {
      let response = await ApiService.client
        .post(
          `/auth/register`,
          {
            username: inputUsername,
            email: inputEmail,
            password: inputPassword,
            role_id: inputRole,
          },
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deleteUser = async (dataUser) => {
    try {
      let response = await ApiService.client
        .delete(
          `/auth/delete/` + dataUser.row.cells[0].value,
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    try {
      const fetchData = async () => {
        try {
          skipPageResetRef.current = true;
          let responseRole = await ApiService.client.get(
            `/auth/getRoles/${pageIndex + 1
            }/500`,
            await ApiService.options()
          );
          let response = await ApiService.client.get(
            `/auth/getAllUsers/${pageIndex + 1
            }/${dataPageSize}`,
            await ApiService.options()
          );
         // console.log("total halaman", responseRole.data.role);
          setDataPage(response.data["total_halaman"]);
          setPageSize(dataPageSize);
          setSelectedOptionsRole(responseRole.data.role)
          setData(response.data.data);
          skipPageResetRef.current = false;
        } catch (error) {
          if (error.response.status === 401) {
            // AuthService.logout().then(
            //   () => {
           //     console.log("Success Logout");
            //   },
            //   (error) => {
            //     (error.response &&
            //       error.response.data &&
            //       error.response.data.message) ||
            //       error.message ||
            //       error.toString();
            //   }
            // );
            // history.push("/auth/sign-in");
          }

          // console.log("error ni", error.response.status);
        }
      };
      fetchData();
    } catch (error) {
      if (error.response.status === 401) {
        // history.push("/auth/sign-in");
      }
      // console.log(error);
    }
  }, [pageIndex, dataPage, dataPageSize, pageSize]);

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  function setRow(data) {
    setSelectedRow(data);
    onOpen(true);
  }

  function setRowUpdate(data) {
    setSelectedRow(data);
   // console.log("DATAA", data.row.cells[4].value)
    setUsername(data.row.cells[0].value);
    setEmail(data.row.cells[1].value);
    setPassword(data.row.cells[2].value);
    setRole(data.row.cells[4].value)
    onOpen2(true);
  }

  function setRowDelete(data) {
    setSelectedRow(data);
    onOpen1(true);
  }

  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", md: "scroll", lg: "scroll" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          User Management
        </Text>
        {/* <Menu /> */}
      </Flex>

      {/* Modal For Disable/Enable User */}
      <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(0deg)"
        />
        <ModalContent>
          <ModalHeader>Please Confirm</ModalHeader>
          <ModalBody>Are you sure to do this?</ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="red"
              onClick={() => enableDisableUser(selectedRow)}
            >
              Yes
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal For Create User */}
      <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={isOpen3}
        onClose={onClose3}
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(0deg)"
        />
        <ModalContent>
          <ModalHeader>Create User</ModalHeader>
          <ModalBody>
            <InputGroup mb={5}>
              <InputLeftAddon children="Username" />
              <Input
                focusBorderColor="black"
                placeholder="Input Username"
                borderRadius="16px"
                value={inputUsername}
                onChange={(e) => setUsername(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={5}>
              <InputLeftAddon children="Email" />
              <Input
                focusBorderColor="black"
                placeholder="Input Email"
                borderRadius="16px"
                value={inputEmail}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={5}>
              <InputLeftAddon children="Password" />
              <Input
                focusBorderColor="black"
                placeholder="Input Password"
                borderRadius="16px"
                value={inputPassword}
                type={show ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement width="4.5rem">
                <Button h="1.75rem" size="sm" onClick={handleClick}>
                  {show ? "Hide" : "Show"}
                </Button>
              </InputRightElement>
            </InputGroup>
            <InputGroup>
              <InputLeftAddon children="User Group" />
              <Select
                value={inputRole}
                onChange={(e) => setRole(e.target.value)}
                // onClick={(e) => setRole(e.target.value)}
              >
                <option value="" disabled={inputRole !== ""}>Select a user group</option>
                {selectedOptionsRole.map(function (data) {
                  return <option key={data.id} value={data.id}>{data.role_name}</option>;
                })}
              </Select>
            </InputGroup>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose3}>
              Cancel
            </Button>
            <Button colorScheme="facebook" onClick={() => registerUser()}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal For Update User */}
      <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={isOpen2}
        onClose={onClose2}
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(0deg)"
        />
        <ModalContent>
          <ModalHeader>Update User</ModalHeader>
          <ModalBody>
            <InputGroup mb={5}>
              <InputLeftAddon children="Email" />
              <Input
                focusBorderColor="black"
                placeholder="Input Email"
                borderRadius="16px"
                value={inputEmail}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={5}>
              <InputLeftAddon children="Password" />
              <Input
                focusBorderColor="black"
                placeholder="Input Password"
                borderRadius="16px"
                value={inputPassword}
                type="password"
                onChange={(e) => setPassword(e.target.value)}
              />
              {/* <InputRightElement width='4.5rem'>
        <Button h='1.75rem' size='sm' onClick={handleClick}>
          {show ? 'Hide' : 'Show'}
        </Button>
      </InputRightElement> */}
            </InputGroup>
            <InputGroup mb={5}>
              <InputLeftAddon children="User Group" />
              <Select
                value={inputRole}
                onChange={(e) => setRole(e.target.value)}
                // onClick={(e) => setRole(e.target.value)}
              >
                <option value="" disabled={inputRole !== ""}>Select a user group</option>
                {selectedOptionsRole?.map(function (data) {
                  return <option key={data.id} value={data.id}>{data.role_name}</option>;
                })}
              </Select>
            </InputGroup>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose2}>
              Cancel
            </Button>
            <Button
              colorScheme="facebook"
              onClick={() => updateUser(selectedRow)}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Alert For Delete User */}
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay
          bg="none"
          backdropFilter="auto"
          backdropInvert="100%"
        >
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete User
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={() => deleteUser(selectedRow)}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <Stack
        px="20px"
        justify="space-between"
        mb="20px"
        align="center"
        spacing={4}
        direction="row"
      >
        <Button
          leftIcon={<MdCreate />}
          colorScheme="blue"
          size="md"
          borderRadius="lg"
          onClick={onOpen3}
        >
          Create
        </Button>
      </Stack>

      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data = "";
                  if (cell.column.Header === "USERNAME") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "EMAIL") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "PASSWORD (Encrypted)") {
                    data = (
                      <Text
                        color={textColor}
                        type="password"
                        fontSize="sm"
                        fontWeight="700"
                      >
                        *********
                      </Text>
                    );
                  } else if (cell.column.Header === "USER GROUP") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "ACTIVE") {
                    data = (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color={
                            cell.row.cells[3].value === true
                              ? "green.500"
                              : cell.row.cells[3].value !== true
                                ? "red.500"
                                : null
                          }
                          as={
                            cell.row.cells[3].value === true
                              ? MdCheckCircle
                              : cell.row.cells[3].value !== true
                                ? MdCancel
                                : null
                          }
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.row.cells[3].value === true
                            ? "Active"
                            : "Disable"}
                        </Text>
                      </Flex>
                    );
                  } else if (cell.column.Header === "UPDATE") {
                    data = (
                      <Button
                        leftIcon={<MdUpdate />}
                        colorScheme="teal"
                        size="sm"
                        borderRadius="xl"
                        onClick={() => setRowUpdate(cell)}
                      >
                        Update
                      </Button>
                    );
                  } else if (cell.column.Header === "DISABLE") {
                    data = (
                      <Button
                        leftIcon={<MdWarning />}
                        colorScheme="orange"
                        size="sm"
                        borderRadius="xl"
                        onClick={() => setRow(cell)}
                        isDisabled={
                          cell.row.cells[0].value === "admin" ? true : false
                        }
                      >
                        {cell.row.cells[3].value === true
                          ? "Disable"
                          : "Enable"}
                      </Button>
                    );
                  } else if (cell.column.Header === "DELETE") {
                    data = (
                      <Button
                        isDisabled={
                          cell.row.cells[3].value === true ? true : false
                        }
                        leftIcon={<MdDelete />}
                        colorScheme="red"
                        size="sm"
                        borderRadius="xl"
                        onClick={() => setRowDelete(cell)}
                      >
                        Delete
                      </Button>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Pagination
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        gotoPage={gotoPage}
        pageSize={pageSize}
        setDataPageSize={setDataPageSize}
        pageCount={pageCount}
      />
    </Card>
  );
}
